//
//
//
//
//
//
//
//
//
//

import Badge from "@Shared/components/general/badge";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationStatusBadge",
  components: {
    Badge
  },
  props: {
    applicationStatus: {
      type: String,
      required: true
    }
  },
  computed: {
    badgeType() {
      const badgeTypeMap = {
        new: "dark",
        pending: "dark",
        submitted: "dark",
        "in-review": "dark",
        completed: "success",
        cancelled: "danger"
      };
      return badgeTypeMap[this.applicationStatus] || "dark";
    }
  },
  methods: {
    getStatusLabel(applicationStatus) {
      return this.$t(`application.status.${applicationStatus}`);
    }
  }
});